import { render, staticRenderFns } from "./MyItems.vue?vue&type=template&id=13a22e84&scoped=true&"
import script from "./MyItems.vue?vue&type=script&lang=js&"
export * from "./MyItems.vue?vue&type=script&lang=js&"
import style0 from "./MyItems.vue?vue&type=style&index=0&id=13a22e84&lang=scss&scoped=true&"
import style1 from "./MyItems.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./MyItems.vue?vue&type=style&index=2&lang=scss&"
import style3 from "@/styles/items.scss?vue&type=style&index=3&id=13a22e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a22e84",
  null
  
)

export default component.exports